import Swiper from "swiper";
import {
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
  Controller,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";

document.addEventListener("DOMContentLoaded", function () {
  // Inicjalizacja slidera na górze strony
  var swiperTop = new Swiper(".product-info__slider .swiper", {
    modules: [Navigation],
    navigation: {
      enabled: true,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  document.querySelectorAll(".swiper-button").forEach(function (element) {
    element.addEventListener("click", function () {
      var slideIndex = parseInt(this.getAttribute("data-slide-to"));
      swiperTop.slideTo(slideIndex);
    });
  });
});
